module.exports = "/_next/static/images/933b5634646d36e8b203efa766cbdfce-hero-lg.jpg.webp";